/* eslint-disable prettier/prettier */
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { LOCALES } from './types';

export const SORTED_PROD_SUPPORTED_LOCALES = [
  LOCALES.ca_es,
  LOCALES.cs_cz,
  LOCALES.de_aq,
  LOCALES.de_at,
  LOCALES.de_ch,
  LOCALES.de_de,
  LOCALES.en_aq,
  LOCALES.en_at,
  LOCALES.en_ca,
  LOCALES.en_ch,
  LOCALES.en_cz,
  LOCALES.en_de,
  LOCALES.en_es,
  LOCALES.en_gb,
  LOCALES.en_nz,
  LOCALES.en_pl,
  LOCALES.en_pt,
  LOCALES.en_ro,
  LOCALES.en_us,
  LOCALES.en_za,
  LOCALES.es_aq,
  LOCALES.es_es,
  LOCALES.es_pt,
  LOCALES.eu_es,
  LOCALES.fr_aq,
  LOCALES.fr_ca,
  LOCALES.fr_ch,
  LOCALES.gl_es,
  LOCALES.it_aq,
  LOCALES.it_ch,
  LOCALES.nl_nl,
  LOCALES.pt_es,
  LOCALES.pl_pl,
  LOCALES.pt_pt,
  LOCALES.ro_ro,
];
